module.exports = __webpack_public_path__ + "img/dark_oak_1.750b5fb4.jpg";